import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import KindService from "../../../../services/catalogs/KindService";

export const REQUEST_UPDATE_KIND = "REQUEST_UPDATE_KIND";
export const UPDATE_KIND_SUCCESS = "UPDATE_KIND_SUCCESS";
export const UPDATE_KIND_ERROR = "UPDATE_KIND_ERROR";

function requestUpdateKind() {
  return {
    type: REQUEST_UPDATE_KIND,
  };
}

function updateKindSuccess(json) {
  return {
    type: UPDATE_KIND_SUCCESS,
    message: json.data,
  };
}

function updateKindError(json) {
  return {
    type: UPDATE_KIND_ERROR,
    error: json.data,
  };
}

export function updateKind(kind_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateKind());
    return KindService.putKind(kind_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateKindSuccess(json.data));
      } else if(json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateKind(kind_id), payload);
      } else if(json.data.code === 498){
        logOut();
      } else {
        dispatch(updateKindError(json.data));
      }
    });
  };
}
